import { createSlice } from "@reduxjs/toolkit";

export const modals = createSlice({
  name: "modals",
  initialState: {
    addProductCompatibilityModalIsOpen: false,
    addProductCompatibilityModalProps: null,
    addCompatibilityModalIsOpen: false,
    addCompatibilityModalProps: null,
  },
  reducers: {
    showOrHideModal: (state, action) => {
      const {
        addProductCompatibilityModalIsOpen,
        addProductCompatibilityModalProps,
        addCompatibilityModalIsOpen,
        addCompatibilityModalProps,
      } = action.payload;
      if (addProductCompatibilityModalIsOpen !== undefined) {
        state.addProductCompatibilityModalIsOpen =
          addProductCompatibilityModalIsOpen;
      }
      if (addProductCompatibilityModalProps !== undefined) {
        state.addProductCompatibilityModalProps =
          addProductCompatibilityModalProps;
      }
      if (addCompatibilityModalIsOpen !== undefined) {
        state.addCompatibilityModalIsOpen = addCompatibilityModalIsOpen;
      }
      if (addCompatibilityModalProps !== undefined) {
        state.addCompatibilityModalProps = addCompatibilityModalProps;
      }
    },
  },
});

// Action creators are generated for each case reducer function
export const { showOrHideModal } = modals.actions;

export default modals.reducer;
